if($('.jewelleryResults').length){
    var customJeveleryresult = '<div id="customFilters"></div>'
    customJeveleryresult += '<div id="customResults"></div>'
    customJeveleryresult += '<div class="customPagination" id="customPagination"></div>'
    $('.jewelleryResults').html(customJeveleryresult)
    $(document).ready(function () {
        const itemsPerPage = 60;
        let currentPage = 1;
        let filteredData = [];
        
        const stoneSizeMap = {
            'Briliantový': ['4.50 mm', '5.00 mm', '5.50 mm', '6.00 mm'],
            'Ovál': ['7x5 mm', '8x6 mm'],
            'Emerald': ['7x5 mm', '8x6 mm']
        };

        function normalizeString(str) {
            return str
                .toLowerCase()
                .replace(/\s+/g, '_')
                .replace(/[áäčďéěíňóöřšťúůüýž]/g, function(match) {
                    const map = {
                        'á': 'a', 'ä': 'a', 'č': 'c', 'ď': 'd', 'é': 'e', 'ě': 'e',
                        'í': 'i', 'ň': 'n', 'ó': 'o', 'ö': 'o', 'ř': 'r', 'š': 's',
                        'ť': 't', 'ú': 'u', 'ů': 'u', 'ü': 'u', 'ý': 'y', 'ž': 'z'
                    };
                    return map[match];
                });
        }

        // Load the JSON file
        $.getJSON('/user/documents/kombinace_prstenu.json?v=' + new Date().getMinutes(), function (jsonData) {
            // Save to session storage
            sessionStorage.setItem('kombinaceData', JSON.stringify(jsonData));
        
            // Function to create filter options
            function createFilters(data) {
                let filters = {};
                data.forEach(item => {
                    for (let key in item) {
                        if (key !== 'OBRÁZEK 1' && key !== 'OBRÁZEK 2' && key !== 'Cena' && key !== 'ID' && key !== 'Velikost kamene' && key !== 'Další možnosti') {
                            if (!filters[key]) {
                                filters[key] = new Set();
                            }
                            filters[key].add(item[key]);
                        }
                    }
                });
                for (let key in filters) {
                    let normalizedKey = normalizeString(key);
                    if (normalizedKey === 'obrazek_1' || normalizedKey === 'obrazek_2' || normalizedKey === 'jmeno') {
                        continue;
                    }
                    
                    let filterContainer = $(`<div class="filter" id="filter-${normalizedKey}"><h3>${key}</h3><div class="filterGroup"></div>`);
                    filters[key].forEach(value => {
                        let imageUrl = findImageForFilter(key, value);
                        let filterOption = $(`<label class="${imageUrl ? 'haveimage' : 'notimage'}"><input type="checkbox" name="${key}" value="${value}"> ${imageUrl ? `<span class="image"><img src="${imageUrl}" alt="${value}"></span> ` : ''}${value}</label>`);
                        filterContainer.find('.filterGroup').append(filterOption);
                    });
                    $('#customFilters').append(filterContainer);
                }
        
                // Add size filter
                let sizeFilterContainer = $(
                    `<div class="slider-container filter" id="slider-velikost_prstenu">
                        <div class="slider-label"><h3>Velikost prstenu</h3></div>
                        <div class="slider-content">
                        <div class="slider" id="size-slider"></div>
                        <div class="slider-values"> <div id="size-value"></div></div>
                        </div>
                    </div>`
                );
                $('#customFilters').append(sizeFilterContainer);
        
                // Add stone size filter
                let stoneSizeFilterContainer = $(
                    `<div class="filter" id="filter-velikost_kamene">
                        <h3>Velikost kamene</h3>
                        <div class="filterGroup">Nejdříve vyberte tvar kamene</div>
                    </div>`
                );
                $('#customFilters').append(stoneSizeFilterContainer);
        
                // Initialize sliders
                $("#size-slider").slider({
                    range: true,
                    min: 46,
                    max: 60,
                    //values: [40, 60],
                    value: 46,
                    slide: function (event, ui) {
                        $("#size-value").text(ui.value);
                        updateValuePosition(ui.handle, ui.value);
                        //$("#size-min").text(ui.values[0]);
                        //$("#size-max").text(ui.values[1]);
                    },
                    change: function (event, ui) {
                        updateValuePosition(ui.handle, ui.value);
                        filterAndDisplayData();
                        $('.chooseMap li[data-filter="slider-velikost_prstenu').addClass('choosen')
                    }
                });
                $("#size-slider .ui-slider-handle:first").remove();
                $("#size-value").text($("#size-slider").slider("value"));

                function updateValuePosition(handle, value) {
                    var offset = $(handle).offset();
                    $("#size-value").offset({
                       // top: offset.top + 25, // Nastavení dle potřeby
                        left: offset.left + 0
                    }).text(value);
                   
                 
                }
                
                // Aktualizujte prvotní zobrazení hodnoty a její pozici
                var initialHandle = $("#size-slider .ui-slider-handle");
                $("#size-value").text($("#size-slider").slider("value"));
                updateValuePosition(initialHandle, $("#size-slider").slider("value"));
               
            }

            function findImageForFilter(key, value) {
                // Define a map of filter values to image URLs
                const imageMap = {
                    'Briliantový': '/user/documents/upload/filtrace/vybrusBriliantovy.png',
                    'Ovál': '/user/documents/upload/filtrace/vybrusOval.png',
                    'Emerald': '/user/documents/upload/filtrace/vybrusEmerald.png',
                    'Bílé zlato': '/user/documents/upload/filtrace/materialBileAu.png',
                    'Žluté zlato': '/user/documents/upload/filtrace/materialZluteAu.png',
                    'Růžové zlato': '/user/documents/upload/filtrace/materialRuzoveAu.png',
                    'Platina': '/user/documents/upload/filtrace/materialPlatina.png',
                    'Solitér': '/user/documents/upload/filtrace/designSoliter.png',
                    'S kameny na kroužku': '/user/documents/upload/filtrace/designsKamenyNaSince.png',
                    'Se třemy kameny': '/user/documents/upload/filtrace/designSeTremiKameny.png',
                    'S haló': '/user/documents/upload/filtrace/designHalo.png',
                };
            
                return imageMap[value] || null; // Return the image URL if found, otherwise return null
            }
        
            // Function to filter and select unique products with the lowest price
            function filterUniqueProducts(data) {
                let productMap = {};
            
                data.forEach(item => {
                    let productName = item['Jméno'];
                    if (!productMap[productName] || item.Cena < productMap[productName].Cena) {
                        productMap[productName] = item;
                    }
                });
                console.log("Unique Products: ", productMap);
                return Object.values(productMap);
            }
            
        
            $(document).on('change', '.filter input[type="checkbox"]', function () {
                if ($(this).is(':checked')) {
                    $(this).closest('label').addClass('activeFilter');
                    $(this).closest('.filter').addClass('activeFilter');
                    $('.chooseMap li[data-filter="'+$(this).closest('.filter').attr('id')+'"]').addClass('choosen')
                    
                } else {
                    $(this).closest('label').removeClass('activeFilter');
                    $(this).closest('.filter').removeClass('activeFilter');
                    $('.chooseMap li[data-filter="'+$(this).closest('.filter').attr('id')+'"]').removeClass('choosen')
                }
                if ($(this).attr('name') === 'Tvar kamene') {
                    updateStoneSizeFilter();
                }
                filterAndDisplayData();
            });
        
            function updateStoneSizeFilter() {
                let selectedShape = $('.filter input[name="Tvar kamene"]:checked').val();
                let filterGroup = $('#filter-velikost_kamene .filterGroup');
               
                if (selectedShape) {
                    let sizes = stoneSizeMap[selectedShape] || [];
                    filterGroup.empty();
                    sizes.forEach(size => {
                        let filterOption = $(`<label><input type="checkbox" name="Velikost kamene" value="${size}"> ${size}</label>`);
                        filterGroup.append(filterOption);
                    });
                } else {
                    filterGroup.text('Nejdříve vyberte tvar kamene');
                }
            }
        
            // Function to filter data based on selected options
            function filterData(data) {
                let selectedFilters = {};
                let uniqueFilters = ['Design',]; // Seznam filtrů, které aktivují funkci pro jedinečné produkty
            
                $('.filter input:checked').each(function () {
                    let key = $(this).attr('name');
                    let value = $(this).val().trim(); // Remove any extra spaces
                    if (!selectedFilters[key]) {
                        selectedFilters[key] = [];
                    }
                    selectedFilters[key].push(value);
                });
            
                // Debug: Log selected filters
                console.log("Selected Filters: ", selectedFilters);
            
                // Filter data based on selected filters
                let filteredData = data.filter(item => {
                    for (let key in selectedFilters) {
                        let itemValue = item[key].trim(); // Remove any extra spaces
                        if (selectedFilters[key].length > 0 && !selectedFilters[key].includes(itemValue)) {
                            return false;
                        }
                    }
                    return true;
                });
            
                // Check if any of the unique filters are selected
                let applyUniqueFilter = false;
                for (let key in selectedFilters) {
                    if (uniqueFilters.includes(key)) {
                        applyUniqueFilter = true;
                        break;
                    }
                }
            
                if (applyUniqueFilter) {
                    // Select unique products with the lowest price
                    let productMap = {};
                    filteredData.forEach(item => {
                        let productName = item['Jméno'];
                        let design = item['Design'];
                        let material = item['Materiál'];
                      //  let dalsiMoznosti = item['Další možnosti'];
                        let tvarKamene = item['Tvar kamene'];
                        let velikostKamene = item['Velikost kamene'];
                        let centralniKamen = item['Centrální kámen'];
                       // let uniqueKey = `${productName}-${design}-${material}-${dalsiMoznosti}-${tvarKamene}-${velikostKamene}-${centralniKamen}`; // Create a unique key
                        let uniqueKey = `${productName}-${design}-${material}-${tvarKamene}-${velikostKamene}-${centralniKamen}`
                       // let uniqueKey = productName + material; // Use a combination of product name and material as the unique key
                        if (!productMap[uniqueKey] || item.Cena < productMap[uniqueKey].Cena) {
                            productMap[uniqueKey] = item;
                        }
                    });
                    filteredData = Object.values(productMap);
                }
            
                // Debug: Log filtered data
                console.log("Filtered Data: ", filteredData);
            
                return filteredData;
            }
        
            // Function to display paginated data
            function displayDataPage(data, page) {
                $('#customResults').empty();
                let start = (page - 1) * itemsPerPage;
                let end = Math.min(start + itemsPerPage, data.length);
                for (let i = start; i < end; i++) {
                    let item = data[i];
                    var customProduct = '<div class="result-item" data-id="' + item['ID'] + '" data-name="' + item['Jméno'] + '" data-id="' + item['Cena'] + '" data-centralniKamen="' + item['Centrální kámen'] + '" data-design="' + item['Design'] + '" data-material="' + item['Materiál'] + '" data-tvarKamene="' + item['Tvar kamene'] + '" data-velikostKamene="' + item['Velikost kamene'] + '" data-dalsiMoznosti="' + item['Další možnosti'] + '">'
                    customProduct += '<div class="image"><img src="/user/documents/customFiltration/' + item['OBRAZEK_1'] + '" data-first="/user/documents/customFiltration/' + item['OBRAZEK_1'] + '" data-second="/user/documents/customFiltration/' + item['OBRAZEK_2'] + '"><span class="bigsize" data-big="/user/documents/customFiltration/' + item['OBRAZEK_1'] + '"></span></div>'
                    customProduct += '<div class="namePrizeLine"><span class="name">' + item['Jméno'] + '</span><span class="prize">' + Number(item['Cena']).ShoptetFormatAsCurrency() + '</span></div>'
                    customProduct += '<div class="button"><span class="messageButton">Poptat</span></div>'
                    customProduct += '</div>'
                    $('#customResults').append(customProduct);

                    if (i === start + 7 || i === end - 1) {
                        $('#customResults').append($('footer#footer .customFiltrationProductsBanner').clone());
                    }
                }
                
                displayPagination(data, page);
                if(!$('.jewelleryResults .customFiltrationBanner').length){
                    $('.jewelleryResults').append($('footer#footer .customFiltrationBanner').clone());
                }
               
            }
        
            //function image to colorbox
            $(document).on('click', '.bigsize', function(){
                var imageUrl = $(this).attr('data-big')
                $.colorbox({
                    href: imageUrl,
                    maxWidth: '95%',
                    width:800,
                    maxHeight: '95%',
                    height:800,
                    photo: true
                });
            })
            // Function to display pagination
            function displayPagination(data, page) {
                $('#customPagination').empty();
                let totalPages = Math.ceil(data.length / itemsPerPage);
                let pagesToShow = 5;
                let startPage = Math.max(1, page - Math.floor(pagesToShow / 2));
                let endPage = Math.min(totalPages, startPage + pagesToShow - 1);
        
                if (endPage - startPage + 1 < pagesToShow) {
                    startPage = Math.max(1, endPage - pagesToShow + 1);
                }
        
                if (startPage > 1) {
                    let prevArrow = $('<span data-page="' + (startPage - 1) + '" class="pagination pagination-prev"></span>');
                    $('#customPagination').append(prevArrow);
                }
        
                for (let i = startPage; i <= endPage; i++) {
                    let pageLink = $('<span data-page="' + i + '">' + i + '</span>');
                    if (i === page) {
                        pageLink.addClass('active');
                    }
                    $('#customPagination').append(pageLink);
                }
        
                if (endPage < totalPages) {
                    let nextArrow = $('<span data-page="' + (endPage + 1) + '" class="pagination pagination-next"></span>');
                    $('#customPagination').append(nextArrow);
                }
            }
        
            // Event listener for filter changes
            $(document).on('change', '.filter input', function () {
      
                filterAndDisplayData();
            });
        
            // Event listener for pagination links
            $(document).on('click', '#customPagination span', function (e) {
                e.preventDefault();
                currentPage = $(this).data('page');
                displayDataPage(filteredData, currentPage);
            });
        
            // Function to filter and display data
            function filterAndDisplayData() {
                let allData = JSON.parse(sessionStorage.getItem('kombinaceData'));
                let filteredData = filterData(allData);
                displayDataPage(filteredData, 1); // Display the first page of filtered data
            }
        
            $(document).on("mouseenter", '.result-item img', function () {
                var img = $(this).attr('data-second');
                if (img) {
                    $(this).attr('src', img);
                }
            });
            $(document).on("mouseleave", '.result-item img', function () {
                var img = $(this).attr('data-first');
                if (img) {
                    $(this).attr('src', img);
                }
            });
        
            // Initial setup
            createFilters(jsonData);
            filteredData = filterUniqueProducts(jsonData); // Initialize with unique data
            displayDataPage(filteredData, 1); // Display the first page of unique data
        });        
    });
    $(document).on('click', '#customFilters .filter h3', function(){
        let $currentFilter = $(this).closest('.filter');
        if ($currentFilter.hasClass('active')) {
            $currentFilter.removeClass('active');
        } else {
            $('.filter').removeClass('active');
            $currentFilter.addClass('active');
        }
    })
    $(document).on('click', '.result-item .messageButton', function(){
        $.colorbox({
            html: '<div class="customFormPoptavka">'+$('footer#footer .customFormPoptavka').html()+'</div>',
            width: 800,
            maxWidth: "95%",
            height: 750,
            maxHeight: "95%",
            className: "customFormPoptavka",
            onComplete: function() {
                
            }
        })
        $('.customJewelleryForm #id').val($(this).closest('.result-item').attr('data-id'))
        $('.customJewelleryForm #jmeno').val($(this).closest('.result-item').attr('data-name'))
        $('.customJewelleryForm #design').val($(this).closest('.result-item').attr('data-design'))
        $('.customJewelleryForm #material').val($(this).closest('.result-item').attr('data-material'))
        $('.customJewelleryForm #centralniKamen').val($(this).closest('.result-item').attr('data-centralniKamen'))
        $('.customJewelleryForm #tvarkamene').val($(this).closest('.result-item').attr('data-tvarKamene'))
        $('.customJewelleryForm #velikostkamene').val($(this).closest('.result-item').attr('data-velikostKamene'))
        $('.customJewelleryForm #velikostprstenu').val($(this).closest('.jewelleryResults').find('#customFilters div#slider-velikost_prstenu #size-value').text())
        $('.customJewelleryForm #cena').val($(this).closest('.result-item').find('.prize').text())
      //  $('.customJewelleryForm #dalsimoznosti').val($(this).closest('.result-item').attr('data-dalsimoznosti'))
    })

    $(document).on('submit', '.customJewelleryForm', function(e){
        $(this).addClass('loading-form')
        e.preventDefault(); 
        var formName = $(this).find('#name').val()
        var formEmail = $(this).find('#email').val()
        var formTel = $(this).find('#telphone').val()
        var formid = $(this).find('#id').val()
        var formjmeno = $(this).find('#jmeno').val()
        var formdesign = $(this).find('#design').val()
        var formmaterial = $(this).find('#material').val()
        var formcentralniKamen = $(this).find('#centralniKamen').val()
        var formtvarkamene = $(this).find('#tvarkamene').val()
        var formvelikostkamene = $(this).find('#velikostkamene').val()
        var formvelikostprstenu = $(this).find('#velikostprstenu').val()
        var formcena = $(this).find('#cena').val()
       // var formdalsimoznosti = $(this).find('#dalsimoznosti').val()
        var formmessage = $(this).find('#message').val()
        var formdata = new FormData();

        formdata.append("name", formName);
        formdata.append("email", formEmail);
        formdata.append("phone", formTel);
        formdata.append("idProduktu", formid);
        formdata.append("jmenoProduktu", formjmeno);
        formdata.append("desing", formdesign);
        formdata.append("material", formmaterial);
        formdata.append("centralniKamen", formcentralniKamen);
        formdata.append("tvarKamene", formtvarkamene);
        formdata.append("velikostKamene", formvelikostkamene);
        formdata.append("velikostPrstenu", formvelikostprstenu);
        formdata.append("cena", formcena);
       // formdata.append("dalsiMoznosti", formdalsimoznosti);
        formdata.append("zprava", formmessage);
        
        var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
        };
        fetch("https://tools.shopcode.cz/e-mail_sender/zlatnictviSalaba/www/", requestOptions)
        .then(response => response.json())
        .then(function(result){
        showMessage('Formulář byl úspěšně odeslán, budeme vás kontaktovat.', 'success', '', false, true);
            if(result.status === 'ok'){
                $('#poptavkovyForm').removeClass('loading-form')
            }
        })
        .catch(function(){
            showMessage('Při odeslání nastala chyba, zkuste to prosím znovu.', 'error', '', false, true);
            $('#poptavkovyForm').removeClass('loading-form')
        })
    });
}
